import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5314830a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "center"
}
const _hoisted_2 = {
  key: 0,
  class: "step"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Who's there??? ")
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "step max-width"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Roll 2D10 + 20 for each Stat... ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "stat" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" STRENGTH ")
const _hoisted_11 = { class: "stat" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" SPEED ")
const _hoisted_13 = { class: "stat" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" INTELLECT ")
const _hoisted_15 = { class: "stat" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" COMBAT ")
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 2,
  class: "step max-width"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Roll 2D10 + 10 for each Save... ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { class: "stat" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" SANITY ")
const _hoisted_24 = { class: "stat" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" FEAR ")
const _hoisted_26 = { class: "stat" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" BODY ")
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 3,
  class: "step max-width"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Select your Class...")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Marine ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Str:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Spd:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Int:", -1))
const _hoisted_37 = { class: "red" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Cbt:", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sanity:", -1))
const _hoisted_40 = { class: "red" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fear:", -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_43 = { class: "red" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Body:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "+1 Wound")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Android ", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Str:", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Spd:", -1))
const _hoisted_49 = { class: "red" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Int:", -1))
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Cbt:", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sanity:", -1))
const _hoisted_54 = { class: "red" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fear:", -1))
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Body:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "+1 Wound"),
  /*#__PURE__*/_createTextVNode(" & "),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "-10 to 1 Stat")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Scientist ", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Str:", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Spd:", -1))
const _hoisted_62 = { class: "red" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Int:", -1))
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Cbt:", -1))
const _hoisted_66 = { class: "red" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sanity:", -1))
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fear:", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Body:", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "+5 to 1 Stat")
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Teamster ", -1))
const _hoisted_73 = { class: "red" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Str:", -1))
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_76 = { class: "red" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Spd:", -1))
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_79 = { class: "red" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Int:", -1))
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_82 = { class: "red" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Cbt:", -1))
const _hoisted_84 = { class: "red" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Sanity:", -1))
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_87 = { class: "red" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fear:", -1))
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_90 = { class: "red" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Body:", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " -", -1))
const _hoisted_93 = {
  key: 4,
  class: "step"
}
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" -10 to 1 Stat... ")
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Strength ", -1))
const _hoisted_98 = { class: "red" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Speed ", -1))
const _hoisted_100 = { class: "red" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Intellect ", -1))
const _hoisted_102 = { class: "red" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Combat ", -1))
const _hoisted_104 = { class: "red" }
const _hoisted_105 = {
  key: 5,
  class: "step"
}
const _hoisted_106 = /*#__PURE__*/_createTextVNode(" +5 to 1 Stat... ")
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Strength ", -1))
const _hoisted_110 = { class: "red" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Speed ", -1))
const _hoisted_112 = { class: "red" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Intellect ", -1))
const _hoisted_114 = { class: "red" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " Combat ", -1))
const _hoisted_116 = { class: "red" }
const _hoisted_117 = {
  key: 6,
  class: "step"
}
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" Roll 1D10 + 10 for your Health... ")
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_121 = ["src"]
const _hoisted_122 = {
  key: 7,
  class: "step"
}
const _hoisted_123 = /*#__PURE__*/_createTextVNode(" Select one Expert Skill or two Trained Skills... ")
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_126 = /*#__PURE__*/_createTextVNode(" Class skills: ")
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_128 = { disabled: "" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_130 = /*#__PURE__*/_createTextVNode(" Trained Skills:")
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_132 = ["onClick"]
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_134 = /*#__PURE__*/_createTextVNode(" Expert Skills: ")
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_136 = ["onClick"]
const _hoisted_137 = ["src"]
const _hoisted_138 = {
  key: 8,
  class: "step>"
}
const _hoisted_139 = /*#__PURE__*/_createTextVNode(" Select 1 Master Skill and an Expert and Trained Skill Prerequisite...Select one Expert Skill or two Trained Skills... ")
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_142 = /*#__PURE__*/_createTextVNode(" Master Skills:")
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_144 = ["onClick"]
const _hoisted_145 = /*#__PURE__*/_createTextVNode(" Expert Skills: ")
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_147 = ["onClick"]
const _hoisted_148 = /*#__PURE__*/_createTextVNode(" Trained Skills: ")
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_150 = ["onClick"]
const _hoisted_151 = ["src"]
const _hoisted_152 = {
  key: 9,
  class: "step"
}
const _hoisted_153 = /*#__PURE__*/_createTextVNode(" Select one Trained Skill and one Expert Skill... ")
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_156 = /*#__PURE__*/_createTextVNode(" Class skills: ")
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_158 = { disabled: "" }
const _hoisted_159 = /*#__PURE__*/_createTextVNode(" Trained Skills:")
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_161 = ["onClick"]
const _hoisted_162 = /*#__PURE__*/_createTextVNode(" Expert Skills: ")
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_164 = ["onClick"]
const _hoisted_165 = ["src"]
const _hoisted_166 = {
  key: 10,
  class: "step"
}
const _hoisted_167 = /*#__PURE__*/_createTextVNode(" A Loadout, Trinket, and Patch have been rolled for you, but may be edited on the next screen. ")
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_170 = /*#__PURE__*/_createTextVNode(" Roll 2D10 x 10 for your Credits... ")
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_173 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarField = _resolveComponent("StarField")!
  const _component_LabeledBox = _resolveComponent("LabeledBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_StarField),
    (!$setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ($setup.step === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.character.name) = $event)),
                  placeholder: "Name"
                }, null, 512), [
                  [_vModelText, $setup.character.name]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.character.pronouns) = $event)),
                  placeholder: "Pronouns"
                }, null, 512), [
                  [_vModelText, $setup.character.pronouns]
                ]),
                _createElementVNode("img", {
                  src: $setup.NextIcon,
                  class: "next",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
                }, null, 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          ($setup.step === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_LabeledBox, {
                  label: "STATS",
                  dark: true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        class: "stat",
                        type: "number",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.character.stats.strength) = $event)),
                        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.validateStats && $setup.validateStats(...args)))
                      }, null, 544), [
                        [_vModelText, $setup.character.stats.strength]
                      ]),
                      _hoisted_10
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        class: "stat",
                        type: "number",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.character.stats.speed) = $event)),
                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.validateStats && $setup.validateStats(...args)))
                      }, null, 544), [
                        [_vModelText, $setup.character.stats.speed]
                      ]),
                      _hoisted_12
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        class: "stat",
                        type: "number",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.character.stats.intellect) = $event)),
                        onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.validateStats && $setup.validateStats(...args)))
                      }, null, 544), [
                        [_vModelText, $setup.character.stats.intellect]
                      ]),
                      _hoisted_14
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        class: "stat",
                        type: "number",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.character.stats.combat) = $event)),
                        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.validateStats && $setup.validateStats(...args)))
                      }, null, 544), [
                        [_vModelText, $setup.character.stats.combat]
                      ]),
                      _hoisted_16
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("img", {
                  src: $setup.NextIcon,
                  class: "next",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
                }, null, 8, _hoisted_17)
              ]))
            : _createCommentVNode("", true),
          ($setup.step === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _hoisted_19,
                _hoisted_20,
                _hoisted_21,
                _createVNode(_component_LabeledBox, {
                  label: "SAVES",
                  dark: true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        class: "stat",
                        type: "number",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.character.saves.sanity) = $event)),
                        onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($setup.validateSaves && $setup.validateSaves(...args)))
                      }, null, 544), [
                        [_vModelText, $setup.character.saves.sanity]
                      ]),
                      _hoisted_23
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        class: "stat",
                        type: "number",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.character.saves.fear) = $event)),
                        onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => ($setup.validateSaves && $setup.validateSaves(...args)))
                      }, null, 544), [
                        [_vModelText, $setup.character.saves.fear]
                      ]),
                      _hoisted_25
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        class: "stat",
                        type: "number",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.character.saves.body) = $event)),
                        onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($setup.validateSaves && $setup.validateSaves(...args)))
                      }, null, 544), [
                        [_vModelText, $setup.character.saves.body]
                      ]),
                      _hoisted_27
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("img", {
                  src: $setup.NextIcon,
                  class: "next",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
                }, null, 8, _hoisted_28)
              ]))
            : _createCommentVNode("", true),
          ($setup.step === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _hoisted_30,
                _hoisted_31,
                _hoisted_32,
                _createElementVNode("button", {
                  class: "class",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.selectClass($setup.Classes.MARINE)))
                }, [
                  _hoisted_33,
                  _createElementVNode("p", null, [
                    _hoisted_34,
                    _createTextVNode(" " + _toDisplayString($setup.character.stats.strength) + " - ", 1),
                    _hoisted_35,
                    _createTextVNode(" " + _toDisplayString($setup.character.stats.speed) + " - ", 1),
                    _hoisted_36,
                    _createTextVNode(" " + _toDisplayString($setup.character.stats.intellect) + " - ", 1),
                    _createElementVNode("span", _hoisted_37, [
                      _hoisted_38,
                      _createTextVNode(" " + _toDisplayString($setup.character.stats.combat + 10), 1)
                    ])
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_39,
                    _createTextVNode(" " + _toDisplayString($setup.character.saves.sanity) + " - ", 1),
                    _createElementVNode("span", _hoisted_40, [
                      _hoisted_41,
                      _createTextVNode(" " + _toDisplayString($setup.character.saves.fear + 20), 1)
                    ]),
                    _hoisted_42,
                    _createElementVNode("span", _hoisted_43, [
                      _hoisted_44,
                      _createTextVNode(" " + _toDisplayString($setup.character.saves.body + 10), 1)
                    ])
                  ]),
                  _hoisted_45
                ]),
                _createElementVNode("button", {
                  class: "class",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.selectClass($setup.Classes.ANDROID)))
                }, [
                  _hoisted_46,
                  _createElementVNode("p", null, [
                    _hoisted_47,
                    _createTextVNode(" " + _toDisplayString($setup.character.stats.strength) + " - ", 1),
                    _hoisted_48,
                    _createTextVNode(" " + _toDisplayString($setup.character.stats.speed) + " - ", 1),
                    _createElementVNode("span", _hoisted_49, [
                      _hoisted_50,
                      _createTextVNode(" " + _toDisplayString($setup.character.stats.intellect + 20), 1)
                    ]),
                    _hoisted_51,
                    _hoisted_52,
                    _createTextVNode(" " + _toDisplayString($setup.character.stats.combat), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_53,
                    _createTextVNode(" " + _toDisplayString($setup.character.saves.sanity) + " - ", 1),
                    _createElementVNode("span", _hoisted_54, [
                      _hoisted_55,
                      _createTextVNode(" " + _toDisplayString($setup.character.saves.fear + 60), 1)
                    ]),
                    _hoisted_56,
                    _hoisted_57,
                    _createTextVNode(" " + _toDisplayString($setup.character.saves.body), 1)
                  ]),
                  _hoisted_58
                ]),
                _createElementVNode("button", {
                  class: "class",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.selectClass($setup.Classes.SCIENTIST)))
                }, [
                  _hoisted_59,
                  _createElementVNode("p", null, [
                    _hoisted_60,
                    _createTextVNode(" " + _toDisplayString($setup.character.stats.strength) + " - ", 1),
                    _hoisted_61,
                    _createTextVNode(" " + _toDisplayString($setup.character.stats.speed) + " - ", 1),
                    _createElementVNode("span", _hoisted_62, [
                      _hoisted_63,
                      _createTextVNode(" " + _toDisplayString($setup.character.stats.intellect + 10), 1)
                    ]),
                    _hoisted_64,
                    _hoisted_65,
                    _createTextVNode(" " + _toDisplayString($setup.character.stats.combat), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", _hoisted_66, [
                      _hoisted_67,
                      _createTextVNode(" " + _toDisplayString($setup.character.saves.sanity + 30), 1)
                    ]),
                    _hoisted_68,
                    _hoisted_69,
                    _createTextVNode(" " + _toDisplayString($setup.character.saves.fear) + " - ", 1),
                    _hoisted_70,
                    _createTextVNode(" " + _toDisplayString($setup.character.saves.body), 1)
                  ]),
                  _hoisted_71
                ]),
                _createElementVNode("button", {
                  class: "class",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.selectClass($setup.Classes.TEAMSTER)))
                }, [
                  _hoisted_72,
                  _createElementVNode("p", null, [
                    _createElementVNode("span", _hoisted_73, [
                      _hoisted_74,
                      _createTextVNode(" " + _toDisplayString($setup.character.stats.strength + 5), 1)
                    ]),
                    _hoisted_75,
                    _createElementVNode("span", _hoisted_76, [
                      _hoisted_77,
                      _createTextVNode(" " + _toDisplayString($setup.character.stats.speed + 5), 1)
                    ]),
                    _hoisted_78,
                    _createElementVNode("span", _hoisted_79, [
                      _hoisted_80,
                      _createTextVNode(" " + _toDisplayString($setup.character.stats.intellect + 5), 1)
                    ]),
                    _hoisted_81,
                    _createElementVNode("span", _hoisted_82, [
                      _hoisted_83,
                      _createTextVNode(" " + _toDisplayString($setup.character.stats.combat + 5), 1)
                    ])
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", _hoisted_84, [
                      _hoisted_85,
                      _createTextVNode(" " + _toDisplayString($setup.character.saves.sanity + 10), 1)
                    ]),
                    _hoisted_86,
                    _createElementVNode("span", _hoisted_87, [
                      _hoisted_88,
                      _createTextVNode(" " + _toDisplayString($setup.character.saves.fear + 10), 1)
                    ]),
                    _hoisted_89,
                    _createElementVNode("span", _hoisted_90, [
                      _hoisted_91,
                      _createTextVNode(" " + _toDisplayString($setup.character.saves.body + 10), 1)
                    ])
                  ]),
                  _hoisted_92
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.step === 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                _hoisted_94,
                _hoisted_95,
                _hoisted_96,
                ($setup.character.stats.strength >= 10)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[23] || (_cache[23] = () => { $setup.character.stats.strength -= 10; $setup.next() }),
                      class: "stat"
                    }, [
                      _hoisted_97,
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString($setup.character.stats.strength) + " to ", 1),
                        _createElementVNode("span", _hoisted_98, _toDisplayString($setup.character.stats.strength - 10), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.character.stats.speed >= 10)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[24] || (_cache[24] = () => { $setup.character.stats.speed -= 10; $setup.next() }),
                      class: "stat"
                    }, [
                      _hoisted_99,
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString($setup.character.stats.speed) + " to ", 1),
                        _createElementVNode("span", _hoisted_100, _toDisplayString($setup.character.stats.speed - 10), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.character.stats.intellect >= 10)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      onClick: _cache[25] || (_cache[25] = () => { $setup.character.stats.intellect -= 10; $setup.next() }),
                      class: "stat"
                    }, [
                      _hoisted_101,
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString($setup.character.stats.intellect) + " to ", 1),
                        _createElementVNode("span", _hoisted_102, _toDisplayString($setup.character.stats.intellect - 10), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.character.stats.combat >= 10)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      onClick: _cache[26] || (_cache[26] = () => { $setup.character.stats.combat -= 10; $setup.next() }),
                      class: "stat"
                    }, [
                      _hoisted_103,
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString($setup.character.stats.combat) + " to ", 1),
                        _createElementVNode("span", _hoisted_104, _toDisplayString($setup.character.stats.combat - 10), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ($setup.step === 6)
            ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                _hoisted_106,
                _hoisted_107,
                _hoisted_108,
                _createElementVNode("button", {
                  onClick: _cache[27] || (_cache[27] = () => { $setup.character.stats.strength += 5; $setup.next() }),
                  class: "stat"
                }, [
                  _hoisted_109,
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString($setup.character.stats.strength) + " to ", 1),
                    _createElementVNode("span", _hoisted_110, _toDisplayString($setup.character.stats.strength +5), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[28] || (_cache[28] = () => { $setup.character.stats.speed += 5; $setup.next() }),
                  class: "stat"
                }, [
                  _hoisted_111,
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString($setup.character.stats.speed) + " to ", 1),
                    _createElementVNode("span", _hoisted_112, _toDisplayString($setup.character.stats.speed +5), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[29] || (_cache[29] = () => { $setup.character.stats.intellect += 5; $setup.next() }),
                  class: "stat"
                }, [
                  _hoisted_113,
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString($setup.character.stats.intellect) + " to ", 1),
                    _createElementVNode("span", _hoisted_114, _toDisplayString($setup.character.stats.intellect +5), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[30] || (_cache[30] = () => { $setup.character.stats.combat += 5; $setup.next() }),
                  class: "stat"
                }, [
                  _hoisted_115,
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString($setup.character.stats.combat) + " to ", 1),
                    _createElementVNode("span", _hoisted_116, _toDisplayString($setup.character.stats.combat +5), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.step === 7)
            ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                _hoisted_118,
                _hoisted_119,
                _hoisted_120,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "stat",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($setup.character.health.maxHealth) = $event)),
                  onChange: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => ($setup.validateHealth && $setup.validateHealth(...args)))
                }, null, 544), [
                  [_vModelText, $setup.character.health.maxHealth]
                ]),
                _createElementVNode("img", {
                  src: $setup.NextIcon,
                  class: "next",
                  onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
                }, null, 8, _hoisted_121)
              ]))
            : _createCommentVNode("", true),
          ($setup.step === 8)
            ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                _hoisted_123,
                _hoisted_124,
                _hoisted_125,
                _createElementVNode("p", null, [
                  _hoisted_126,
                  _hoisted_127,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.character.skills.trained, (skill) => {
                    return (_openBlock(), _createElementBlock("button", _hoisted_128, _toDisplayString(skill), 1))
                  }), 256))
                ]),
                _hoisted_129,
                _createElementVNode("p", null, [
                  _hoisted_130,
                  _hoisted_131,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableTrainedSkills, (skill) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass({'selected': $setup.selectedTrainedSkills.includes(skill)}),
                      onClick: ($event: any) => ($setup.selectTrainedSkill(skill))
                    }, _toDisplayString(skill), 11, _hoisted_132))
                  }), 256))
                ]),
                _hoisted_133,
                _createElementVNode("p", null, [
                  _hoisted_134,
                  _hoisted_135,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableExpertSkills, (skill) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass({'selected': $setup.selectedExpertSkill === skill}),
                      onClick: ($event: any) => ($setup.selectExpertSkill(skill))
                    }, _toDisplayString(skill), 11, _hoisted_136))
                  }), 256))
                ]),
                _createElementVNode("img", {
                  src: $setup.NextIcon,
                  class: "next",
                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
                }, null, 8, _hoisted_137)
              ]))
            : _createCommentVNode("", true),
          ($setup.step === 9)
            ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                _hoisted_139,
                _hoisted_140,
                _hoisted_141,
                _createElementVNode("p", null, [
                  _hoisted_142,
                  _hoisted_143,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scientistAvailableMasterSkills, (skill) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass({'selected': $setup.scientistSelectedMasterSkill?.name === skill.name}),
                      onClick: ($event: any) => {$setup.scientistSelectedMasterSkill = skill; $setup.scientistSelectedExpertSkill = undefined}
                    }, _toDisplayString(skill.name), 11, _hoisted_144))
                  }), 256))
                ]),
                _createElementVNode("p", null, [
                  _hoisted_145,
                  _hoisted_146,
                  ($setup.scientistSelectedMasterSkill)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.scientistSelectedMasterSkill.prerequisites, (skill) => {
                        return (_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass({ 'selected': $setup.scientistSelectedExpertSkill === skill }),
                          onClick: ($event: any) => ($setup.scientistSelectExpertSkill(skill))
                        }, _toDisplayString(skill), 11, _hoisted_147))
                      }), 256))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_148,
                  _hoisted_149,
                  ($setup.scientistSelectedExpertSkill)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.availableTrainedSkills, (skill) => {
                        return (_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass({ 'selected': $setup.scientistSelectedTrainedSkill === skill }),
                          onClick: ($event: any) => ($setup.scientistSelectedTrainedSkill = skill)
                        }, _toDisplayString(skill), 11, _hoisted_150))
                      }), 256))
                    : _createCommentVNode("", true)
                ]),
                ($setup.scientistSelectedExpertSkill && $setup.scientistSelectedExpertSkill && $setup.scientistSelectedTrainedSkill)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: $setup.NextIcon,
                      class: "next",
                      onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
                    }, null, 8, _hoisted_151))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ($setup.step === 10)
            ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                _hoisted_153,
                _hoisted_154,
                _hoisted_155,
                _createElementVNode("p", null, [
                  _hoisted_156,
                  _hoisted_157,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.character.skills.trained, (skill) => {
                    return (_openBlock(), _createElementBlock("button", _hoisted_158, _toDisplayString(skill), 1))
                  }), 256))
                ]),
                _createElementVNode("p", null, [
                  _hoisted_159,
                  _hoisted_160,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableTrainedSkills, (skill) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass({'selected': $setup.selectedTrainedSkills.includes(skill)}),
                      onClick: ($event: any) => ($setup.selectTrainedSkillTeamster(skill))
                    }, _toDisplayString(skill), 11, _hoisted_161))
                  }), 256))
                ]),
                _createElementVNode("p", null, [
                  _hoisted_162,
                  _hoisted_163,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableExpertSkills, (skill) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass({'selected': $setup.selectedExpertSkill === skill}),
                      onClick: ($event: any) => ($setup.selectExpertSkillTeamster(skill))
                    }, _toDisplayString(skill), 11, _hoisted_164))
                  }), 256))
                ]),
                _createElementVNode("img", {
                  src: $setup.NextIcon,
                  class: "next",
                  onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
                }, null, 8, _hoisted_165)
              ]))
            : _createCommentVNode("", true),
          ($setup.step === 11)
            ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                _hoisted_167,
                _hoisted_168,
                _hoisted_169,
                _hoisted_170,
                _hoisted_171,
                _hoisted_172,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "stat",
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($setup.character.credits) = $event))
                }, null, 512), [
                  [_vModelText, $setup.character.credits]
                ]),
                _createElementVNode("img", {
                  src: $setup.NextIcon,
                  class: "next",
                  onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => ($setup.next && $setup.next(...args)))
                }, null, 8, _hoisted_173)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}